(function () {
  'use strict';

  // Same LCG as paper-bg.js
  function makePrng(seed) {
    var s = seed >>> 0;
    return function () {
      s = (Math.imul(1664525, s) + 1013904223) >>> 0;
      return s / 4294967296;
    };
  }

  // Port of Flutter _DistressedRectPainter._buildPath
  function buildPath(w, h, seed) {
    var rng  = makePrng(seed);
    var step = 8;
    var amp  = 0.55;
    function jit() { return (rng() - 0.5) * 2 * amp; }

    var pts = [];
    var xi, yi;
    for (xi = 0; xi <= w; xi += step) pts.push([xi, jit()]);
    pts.push([w, jit()]);
    for (yi = step; yi <= h; yi += step) pts.push([w + jit(), yi]);
    pts.push([w + jit(), h]);
    for (xi = w - step; xi >= 0; xi -= step) pts.push([xi, h + jit()]);
    pts.push([0, h + jit()]);
    for (yi = h - step; yi > 0; yi -= step) pts.push([jit(), yi]);

    function f(v) { return v.toFixed(2); }
    var d = 'M' + f(pts[0][0]) + ',' + f(pts[0][1]);
    for (var i = 0; i < pts.length; i++) {
      var c = pts[i], n = pts[(i + 1) % pts.length];
      d += 'Q' + f(c[0]) + ',' + f(c[1]) + ',' + f((c[0]+n[0])/2) + ',' + f((c[1]+n[1])/2);
    }
    return d + 'Z';
  }

  function buildHLine(w, seed) {
    var rng  = makePrng(seed);
    var step = 6;
    var amp  = 0.4;
    function jit() { return (rng() - 0.5) * 2 * amp; }
    var pts = [];
    for (var xi = 0; xi <= w; xi += step) pts.push([xi, jit()]);
    pts.push([w, jit()]);
    function f(v) { return v.toFixed(2); }
    var d = 'M' + f(pts[0][0]) + ',' + f(pts[0][1]);
    for (var i = 0; i < pts.length - 1; i++) {
      var c = pts[i], n = pts[i + 1];
      d += 'Q' + f(c[0]) + ',' + f(c[1]) + ',' + f((c[0]+n[0])/2) + ',' + f((c[1]+n[1])/2);
    }
    return d;
  }

  function renderHLine(el) {
    var seed  = parseInt(el.dataset.dSeed  || '7', 10);
    var color = el.dataset.dColor || 'rgba(250,246,238,0.45)';
    var sw    = parseFloat(el.dataset.dWidth || '1');
    var w = el.offsetWidth || 28;
    var old = el.querySelector(':scope > .db-svg');
    if (old) old.remove();
    el.style.position = 'relative';
    var svg = document.createElementNS(NS, 'svg');
    svg.className.baseVal = 'db-svg';
    svg.setAttribute('width',  w);
    svg.setAttribute('height', 2);
    svg.style.cssText = 'position:absolute;top:50%;left:0;transform:translateY(-50%);pointer-events:none;overflow:visible;';
    var path = document.createElementNS(NS, 'path');
    path.setAttribute('d',            buildHLine(w, seed));
    path.setAttribute('fill',         'none');
    path.setAttribute('stroke',       color);
    path.setAttribute('stroke-width', sw);
    path.setAttribute('stroke-linejoin', 'round');
    path.setAttribute('stroke-linecap',  'round');
    svg.appendChild(path);
    el.appendChild(svg);
  }

  var NS = 'http://www.w3.org/2000/svg';

  function render(el) {
    var seed  = parseInt(el.dataset.dSeed  || '7', 10);
    var fill  = el.dataset.dFill  || null;
    var color = el.dataset.dColor || '#3A4A1E';
    var sw    = parseFloat(el.dataset.dWidth || '1.4');

    var w = el.offsetWidth;
    var h = el.offsetHeight;
    if (!w || !h) return;

    var old = el.querySelector(':scope > .db-svg');
    if (old) old.remove();

    // isolation:isolate creates a stacking context so z-index:-1 SVG
    // sits behind text content but inside the element boundary
    el.style.position     = 'relative';
    el.style.isolation    = 'isolate';
    el.style.background   = 'none';
    el.style.border       = 'none';
    el.style.borderRadius = '0';

    var svg = document.createElementNS(NS, 'svg');
    svg.className.baseVal = 'db-svg';
    svg.setAttribute('width',  w);
    svg.setAttribute('height', h);
    svg.style.cssText = 'position:absolute;top:0;left:0;pointer-events:none;overflow:visible;z-index:-1;';

    var path = document.createElementNS(NS, 'path');
    path.setAttribute('d',            buildPath(w, h, seed));
    path.setAttribute('fill',         fill || 'none');
    path.setAttribute('stroke',       fill ? 'rgba(10,10,4,0.09)' : color);
    path.setAttribute('stroke-width', sw);
    path.setAttribute('stroke-linejoin', 'round');
    path.setAttribute('stroke-linecap',  'round');
    svg.appendChild(path);

    el.insertBefore(svg, el.firstChild);
  }

  // Assign seed + fill/color from element class/style
  function autoConfig(el, index) {
    if (el.dataset.dSeed) return; // already set explicitly
    el.dataset.dSeed = String(7 + index * 6);

    var c = el.classList;

    // Filled variants
    if (c.contains('btn-olive')) {
      el.dataset.dFill = '#3A4A1E';
    } else if (c.contains('btn-terra')) {
      el.dataset.dFill = '#C4613A';
    } else if (c.contains('add-to-cart')) {
      // colour comes from inline style="background:#XXXXXX" — browser normalises hex to rgb()
      var raw = (el.style.background || el.style.backgroundColor || '').toLowerCase().trim();
      var isTerra = raw.indexOf('c4613a') !== -1 || raw === 'rgb(196, 97, 58)';
      el.dataset.dFill = isTerra ? '#C4613A' : '#3A4A1E';

    // Outlined variants
    } else if (c.contains('btn-outline-olive') || c.contains('cart-link')) {
      el.dataset.dColor = '#3A4A1E';
    } else if (c.contains('btn-outline-terra')) {
      el.dataset.dColor = '#C4613A';
    } else if (c.contains('btn-outline-dark')) {
      el.dataset.dColor = '#0A0A04';
    } else if (c.contains('fork-card')) {
      el.dataset.dColor = c.contains('fork-card--terra') ? '#C4613A' : '#3A4A1E';
    }
  }

  function init() {
    var sel = '.btn, .add-to-cart, .cart-link, .fork-card';
    document.querySelectorAll(sel).forEach(autoConfig);

    var all = document.querySelectorAll('[data-d-seed]:not(.d-hline)');
    if (all.length) {
      all.forEach(render);
      if (typeof ResizeObserver !== 'undefined') {
        var ro = new ResizeObserver(function (entries) {
          entries.forEach(function (e) { render(e.target); });
        });
        all.forEach(function (el) { ro.observe(el); });
      }
    }

    var hlines = document.querySelectorAll('.d-hline');
    if (hlines.length) {
      hlines.forEach(renderHLine);
      if (typeof ResizeObserver !== 'undefined') {
        var roH = new ResizeObserver(function (entries) {
          entries.forEach(function (e) { renderHLine(e.target); });
        });
        hlines.forEach(function (el) { roH.observe(el); });
      }
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
